import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: 9999,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.light,
  },
  itemsBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    marginTop: "95px",
  },
  root: {
    display: "flex",
  },
  drawer: {
    height: "100vh",
    width: "4.166%",
    backgroundColor: "#f5f5f5",
    transition: "width 0.2s ease-in-out",
  },
  listItem: {
    display: "block",
    padding: 0,
    pointerEvents: "none",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  upperListItem: {
    display: "block",
    paddingRight: 2,
    paddingLeft: 2,
    marginTop: "10px",
  },
  listItemButtonTop: {
    textDecoration: "none",
    justifyContent: "center",
    margin: "5px",
    borderRadius: "5px",
    height: "30px",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  listItemButtonOpen: {
    justifyContent: "initial !important",
  },
  listItemButtonIcon: {
    minWidth: 0,
    marginRight: "auto",
    marginLeft: "3px",
    justifyContent: "center",
  },
  listItemButtonIconOpen: {
    marginRight: "3 !important",
  },
  baseTextStyle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0.3px",
    color: "inherit",
  },
  activeTextStyle: {
    fontFamily: "Poppins",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0.3px",
    fontWeight: 600,
    color: "#fff",
  },
  activeButtonStyle: {
    width: "100%",
    height: "50px",
    borderRadius: "6px",
    background: "#4D1277",
    margin: "0px 15px",
    marginBottom: "5px",
    "&:hover": {
      background: "#4D1277",
      color: "#fff",
    },
    //
    "&::before": {
      content: '""',
      position: "absolute",
      left: "-15px",
      top: "0",
      height: "100%",
      width: "6px",
      backgroundColor: "#4D1277",
      borderRadius: "0px 4px 4px 0px",
    },
    //
  },
  listItemButton: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
    // un-selected btn same style
    height: "50px",
    borderRadius: "6px",
    margin: "0px 15px",
    marginBottom: "5px",
    transition: "background 0.2s ease-in-out, color 0.2s ease-in-out", // smooth transition
    //
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  activeIcon: {
    color: "#fff",
  },
}));
export default useStyles;
